<template>
  <div
    class="landing-wrapper"
    :class="[locale]"
  >
    <Landing :config="props.config" />

    <LandingFooter :disclaimer-text="$t('lp_v7_disclaimer')" />
  </div>
</template>

<script lang="ts" setup>
import LandingFooter from '@landing/components/LandingFooter.vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
});

const { $versions } = useNuxtApp();
const { locale } = useI18n();
const route = useRoute();
const { track } = useEventsDispatcher();
const store = useKegelAnalyticStore();
const { initUser } = useEmail();

onMounted(async () => {
  if (import.meta.client) {
    track('Web Mail LP Shown', { number: props.config.version });
    if (route.query.email) {
      store.userEmail = route.query.email as string;
      await initUser(false, store.userEmail);
    }
  }
});

if (import.meta.client) {
  const parsedPath = stripFunnelPrefix(route.path, useFunnelPrefix()).split('/')[2] as string;
  $versions.value.landing = parsedPath;
}
</script>

<style lang="scss" scoped>
.landing-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 8px;
}
</style>
